import axios from "axios";
import { toast } from "../components/toastBridge";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost:3001";

export const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("eds.token");
  if (t) config.headers.Authorization = "Bearer " + t;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    const skipToast = err?.config?.skipToast;

    if (status === 401 && !url.includes("/auth/login")) {
      localStorage.removeItem("eds.token");
      localStorage.removeItem("eds.user");
      if (window.location.pathname !== "/login") window.location.href = "/login";
      return Promise.reject(err);
    }

    // Surface a toast for unexpected errors. Login uses skipToast (the form
    // handles its own error) and 404s on validation flows are silent too.
    if (!skipToast && status >= 500) {
      const msg = err?.response?.data?.error || "Error del servidor.";
      toast(msg, "error");
    }
    return Promise.reject(err);
  }
);

export const apiBase = BASE;
